import { LOGO, PHONE, PHONE_HREF, EMAIL, EMAIL_HREF, WEBSITE, WEBSITE_HREF } from "../lib/content";
import { scrollToId } from "../hooks/useSmoothScroll";
import { NAV } from "../lib/content";

export const Footer = () => (
  <footer className="relative bg-[#1a1410] border-t border-amber-500/15 pt-16 pb-8">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src={LOGO} alt="B. Thornton Capital & Asset Group" className="h-16 w-auto" />
          <p className="mt-5 font-serif italic text-lg text-gold-foil">
            Building Wealth. Restoring Opportunity. Creating Legacy.
          </p>
          <p className="mt-4 text-sm text-zinc-500 max-w-md leading-relaxed">
            Professional Financial &amp; Business Solutions — Asset Recovery ·
            Real Estate Acquisitions · Personal Credit · Business Credit ·
            Business Startup Services.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-amber-500 mb-5">
            Navigate
          </h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <button
                  onClick={() => scrollToId(n.id)}
                  className="text-sm text-zinc-400 hover:text-amber-400 transition-colors"
                >
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] text-amber-500 mb-5">
            Get In Touch
          </h4>
          <a
            href={PHONE_HREF}
            className="text-2xl font-serif text-white hover:text-amber-400 transition-colors"
          >
            {PHONE}
          </a>
          <a
            href={EMAIL_HREF}
            className="mt-3 block text-sm text-zinc-400 hover:text-amber-400 transition-colors break-all"
          >
            {EMAIL}
          </a>
          <a
            href={WEBSITE_HREF}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 block text-sm text-amber-400 hover:text-amber-300 transition-colors break-all"
          >
            {WEBSITE}
          </a>
          <p className="mt-3 text-sm text-zinc-500">
            Serving clients across the United States.
          </p>
          <div className="mt-5 pt-4 border-t border-zinc-800/70">
            <p className="font-serif text-lg text-white">Barry Thornton</p>
            <p className="text-xs uppercase tracking-[0.22em] text-amber-500">Founder</p>
          </div>
          <button
            onClick={() => scrollToId("contact")}
            className="mt-6 border border-amber-500/40 text-amber-300 text-[12px] font-bold tracking-[0.14em] uppercase px-6 py-3 hover:bg-amber-500 hover:text-black transition-colors"
          >
            Free 15-Min Consultation
          </button>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-zinc-600">
          © 2026 B. Thornton Capital &amp; Asset Group. All Rights Reserved.
        </p>
        <p className="text-xs text-zinc-600">
          Professional Financial &amp; Business Solutions
        </p>
      </div>
    </div>
  </footer>
);
